import apiService from '../api/api.service';
import {
  Vehicle,
  CreateVehicleDTO,
  UpdateVehicleDTO,
  AssignVehicleDTO,
  VehicleAssignment
} from '../../types/vehicle.types';

class VehicleService {
  private static instance: VehicleService;

  public static getInstance(): VehicleService {
    if (!VehicleService.instance) {
      VehicleService.instance = new VehicleService();
    }
    return VehicleService.instance;
  }

  private constructor() {}

  /**
   * Yeni araç ekler
   */
  public async createVehicle(data: CreateVehicleDTO): Promise<Vehicle> {
    return apiService.post<Vehicle>('/vehicles', data);
  }

  /**
   * Tüm araçları listeler
   */
  public async getVehicles(): Promise<Vehicle[]> {
    return apiService.get<Vehicle[]>('/vehicles');
  }

  /**
   * Tek bir aracın detaylarını getirir
   */
  public async getVehicleById(id: number): Promise<Vehicle> {
    return apiService.get<Vehicle>(`/vehicles/${id}`);
  }

  /**
   * Bir aracı günceller
   */
  public async updateVehicle(id: number, data: UpdateVehicleDTO): Promise<Vehicle> {
    return apiService.put<Vehicle>(`/vehicles/${id}`, data);
  }

  /**
   * Bir aracı siler
   */
  public async deleteVehicle(id: number): Promise<void> {
    return apiService.delete(`/vehicles/${id}`);
  }

  /**
   * Aracı personele zimmetler
   */
  public async assignVehicle(id: number, data: AssignVehicleDTO): Promise<VehicleAssignment> {
    return apiService.post<VehicleAssignment>(`/vehicles/${id}/assign`, data);
  }

  /**
   * Araç zimmetini iade alır
   */
  public async returnVehicle(id: number): Promise<VehicleAssignment> {
    return apiService.post<VehicleAssignment>(`/vehicles/${id}/return`, {});
  }
}

export default VehicleService.getInstance();
